import { render, staticRenderFns } from "./ScreenLayout.vue?vue&type=template&id=5746561e&"
import script from "./ScreenLayout.vue?vue&type=script&lang=js&"
export * from "./ScreenLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports